import {defineMessages} from 'react-intl';

export default defineMessages({
	bannedMessage: {
		id: 'productView.banned.badge.message',
		defaultMessage: 'Product restrictions apply. Click here for more information.'
	},
});
